import { BrowserModule } from "@angular/platform-browser";
import { LOCALE_ID, NgModule } from "@angular/core";

import { registerLocaleData } from "@angular/common";
import localeNl from "@angular/common/locales/nl";
import localeNlExtra from "@angular/common/locales/extra/nl";

import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PagesModule } from "./pages/pages.module";

registerLocaleData(localeNl, "nl", localeNlExtra);

@NgModule({
    declarations: [AppComponent],
    imports: [BrowserModule, AppRoutingModule, SharedModule, PagesModule],
    providers: [{ provide: LOCALE_ID, useValue: "nl" }],
    bootstrap: [AppComponent],
})
export class AppModule {
    //
}
